import { useEndorsementSummaryMutations } from '@ContractBuilder/hooks/useEndorsementSummaryMutations';
import { useEntityStore } from '@ContractBuilder/store';

export const useBlockActions = () => {
  const {
    addBlockFromLibrary,
    createBlock,
    createBlockInLibrary,
    deactivateBlockInLibrary,
    deleteBlock,
    reactivateBlockInLibrary,
    replaceBlockForBlockInLibrary,
    restoreBlockInLibrary,
    updateBlock,
    updateBlockInLibrary,
  } = useEntityStore(
    ({
      addBlockFromLibrary,
      createBlock,
      createBlockInLibrary,
      deactivateBlockInLibrary,
      deleteBlock,
      reactivateBlockInLibrary,
      replaceBlockForBlockInLibrary,
      restoreBlockInLibrary,
      updateBlock,
      updateBlockInLibrary,
    }) => ({
      addBlockFromLibrary,
      createBlock,
      createBlockInLibrary,
      deactivateBlockInLibrary,
      deleteBlock,
      reactivateBlockInLibrary,
      replaceBlockForBlockInLibrary,
      restoreBlockInLibrary,
      updateBlock,
      updateBlockInLibrary,
    }),
  );

  const {
    createSummaryBlock,
    deleteSummaryBlock,
    hideBlockFromPreview,
    showBlockInPreview,
    restoreAllBlocksHiddenFromPreview,
    updateSummaryBlock,
  } = useEndorsementSummaryMutations();

  return {
    addBlockFromLibrary,
    createBlock,
    createBlockInLibrary,
    createSummaryBlock: createSummaryBlock.mutateAsync,
    deactivateBlockInLibrary,
    deleteBlock,
    deleteSummaryBlock: deleteSummaryBlock.mutateAsync,
    hideBlockFromPreview: hideBlockFromPreview.mutateAsync,
    showBlockInPreview: showBlockInPreview.mutateAsync,
    reactivateBlockInLibrary,
    replaceBlockForBlockInLibrary,
    restoreAllBlocksHiddenFromPreview: restoreAllBlocksHiddenFromPreview.mutateAsync,
    restoreBlockInLibrary,
    updateBlock,
    updateBlockInLibrary,
    updateSummaryBlock: updateSummaryBlock.mutateAsync,
  };
};
